
<!-- <div>
  {{PercentValue | number:'1.0-0'}}

  <progress value = "65" max = "100"/>
</div> -->

<!-- <div style="justify-content: center;"> 

  <span class="newProgressCont">
    <span class="newProgress" style="width:{{PercentValue | number:'1.0-0'}}%; background-color:#0e555c;"></span>
    <span class="newProgressMainCount" style="margin-left: -10px;">
      <span class="newProgressCountWidth" style="width:{{PercentValue | number:'1.0-0'}}%;">
        <span class="newProgressCountCont" style="margin-left: -10px;">
          <span class="newProgressCountArrow" style="border-top-color:#0e555c;">
          </span>
          <span class="newProgressCount">{{PercentValue | number:'1.0-0'}}%</span>
        </span>
      </span>
    </span>
  </span>
</div> -->

<!-- <div>
  <span class="newProgressCont">
    <span class="newProgress" style="width:{{PercentValue | number:'1.0-0'}}%;background-color:#0e555c;"></span>
    <span class="newProgressMainCount" style="margin-left: -10px;">
      <span class="newProgressCountWidth" style="width:33%;"><span class="newProgressCountCont">
          <span class="newProgressCountArrow" style="border-top-color:#0e555c;"></span>
          <span class="newProgressCount">{{PercentValue | number:'1.0-0'}}%</span>
        </span>
      </span>
    </span>
  </span>
</div> -->

<!-- <span class="newProgressCont">
    <span class="newProgress" [style.width]={{PercentValue}} +'%'; style="background-color:#0e555c;"></span>
    <span class="newProgressMainCount" style="margin-left: -10px;">
      <span class="newProgressCountWidth" [style.width]={{PercentValue}} + '%';>
        <span class="newProgressCountCont">
          <span class="newProgressCountArrow" style="border-top-color:#0e555c;"></span>
          <span class="newProgressCount">{{PercentValue | number:'1.0-0'}}%</span>
        </span>
      </span>width
    </span>
  </span>  [ngStyle]="{backgroundColor:GetPercent()} -->  

  <span class="newProgressCont">
			<span class="newProgress" [ngStyle]="{width:GetPercent() +'%'}" style="background-color:#0e555c;" ></span>
      <span class="newProgressMainCount">{{PercentValue | number:'1.0-0'}}%</span>
  </span>
    
    <!-- <span class="newProgressCountWidth" [ngStyle]="{width:GetPercent() +'%'}">
        <span class="newProgressCountCont">
          <span class="newProgressCountArrow" style="border-top-color:#0e555c;"></span>
          
        </span>
      </span> -->

<!-- <div class="progress">
  <div class="progress-bar progress-bar-success progress-bar-striped" role="progressbar" [attr.aria-valuenow]="progress"
    aria-valuemin="0" aria-valuemax="100" style="min-width: 2em;" [style.width]="(progress/100)*100 + '%'">
    {{PercentValue | number:'1.0-0'}}%
  </div> -->